import { useRef, useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

const SplitButton = ({
  disabled,
  onClick,
  options,
  placement = "bottom-start",
}) => {
  const anchorRef = useRef(null);
  const [openPopper, setOpenPopper] = useState(false);

  if (!options || options.length === 0) return null;

  const primary = options[0];

  const handleClick = (index = 0) => {
    const { type } = options[index];
    onClick?.({ type });
    setOpenPopper(false);
  };

  const handleClickAway = (event) => {
    if (anchorRef.current?.contains(event.target)) return;
    setOpenPopper(false);
  };

  const renderPrimaryButton = () => (
    <Button
      size="small"
      onClick={() => handleClick(0)}
      disabled={disabled || primary.disabled}
      variant="contained"
      color="primary"
      startIcon={primary.icon || null} // 👈 bakåtkompatibel
      sx={{
        textTransform: "none",
        gap: primary.icon ? 0.75 : 0,
      }}
    >
      {primary.label}
    </Button>
  );

  if (options.length === 1) {
    return renderPrimaryButton();
  }

  return (
    <>
      <ButtonGroup
        variant="contained"
        color="primary"
        disabled={disabled}
        ref={anchorRef}
      >
        {renderPrimaryButton()}

        <Button
          size="small"
          onClick={() => setOpenPopper((prev) => !prev)}
          sx={{
            minWidth: 28,
            px: 0.5,
            opacity: 0.85,
            "&:hover": { opacity: 1 },
          }}
        >
          <ArrowDropDownIcon fontSize="small" />
        </Button>
      </ButtonGroup>

      <Popper
        open={openPopper}
        anchorEl={anchorRef.current}
        placement={placement}
        transition
        disablePortal
        sx={{ zIndex: 2 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper sx={{ borderRadius: 2 }}>
              <ClickAwayListener onClickAway={handleClickAway}>
                <MenuList dense>
                  {options.slice(1).map((option, index) => (
                    <MenuItem
                      key={option.type || index}
                      disabled={option.disabled}
                      onClick={() => handleClick(index + 1)}
                      sx={{
                        py: 1,
                        px: 2,
                      }}
                    >
                      {/* Ikon om den finns (annars renderas inget) */}
                      {option.icon && (
                        <ListItemIcon sx={{ minWidth: 28 }}>
                          {option.icon}
                        </ListItemIcon>
                      )}

                      <ListItemText
                        primary={option.label}
                        primaryTypographyProps={{
                          fontSize: 14,
                          fontWeight: 500,
                        }}
                      />
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default SplitButton;